import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import SparkApi from "../../api/SparkApi";
// import Warehouse from "../Warehouse";
import helper from "../common/helper";
import * as constants from "../../constants/CONSTANT";
import Warehouse from "../warehouse/Warehouse";
const FactoryView = () => {
    const { id } = useParams();
    const [factory, setFactory] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchFactoryDetail = async () => {
            try {
                const data = await SparkApi.fetchFactoryById(id);
                setFactory(data);
            } catch (error) {
                console.error("Error fetching factory details:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchFactoryDetail();
    }, [id]);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!factory) {
        return <div>Factory not found.</div>;
    }

    return (
        <>
            <Container>
                <Row className="view-form">
                    <Col lg={2} className="pb-3 pt-2">
                        <Link className="nav-link" to="/factory">
                            Home <i className="fa-solid fa-chevron-right"></i>{" "}
                            <div style={{ color: "#23468c", display: "inline" }}>Factory</div>
                        </Link>
                    </Col>
                </Row>
                <Row className="view-form">
                    <Col lg={3}></Col>
                    <Col lg={6}>
                        <Row className="view-form-header">
                            <Col>Factory Detail</Col>
                        </Row>
                        <Row className="py-3 ibs-edit-form">
                            <Col lg={6}>
                                <label>Name</label>
                                <span>{factory?.name || <br />}</span>
                            </Col>
                            <Col lg={6}>
                                <label>Status</label>
                                <span>{factory?.status === 'Active' ? 'Active' : 'InActive' || <br />}</span>
                            </Col>
                            <Col lg={6}>
                                <label>Address</label>
                                <span>{factory?.address || <br />}</span>
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={3}></Col>
                </Row>
            </Container>
            {factory?.status === 'Active' && <Warehouse factoryId={id} />}
        </>
    );
};

export default FactoryView;